export default ($timeout) => {
  'ngInject';

  return {
    restrict: 'A',
    link: (scope, element, attr) => {
      $timeout(function () {
        element.css("display", "none");
      });
    }
  };
}